import tinycolor from 'tinycolor2';

export function getAlphaForBackground(
  background: string,
  initialAlpha: number
) {
  return tinycolor(background).isDark() ? initialAlpha + 0.05 : initialAlpha;
}
